import type { SubscriptionOffer } from "./types";

export type RecurringEvent =
  | "subscription.created"
  | "subscription.confirming"
  | "subscription.active"
  | "subscription.failed";

export function emitRecurringEvent(event: RecurringEvent, offer: SubscriptionOffer, extra: Record<string, unknown> = {}): void {
  const payload = {
    source: "flowgate-recurring",
    event,
    subscription_id: offer.subscription_id,
    status: offer.status,
    reference: offer.reference || null,
    ...extra,
  };
  if (window.parent && window.parent !== window) {
    window.parent.postMessage(payload, "*");
  }
}
